


































    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '@/lib/util'
    import AbpBase from '@/lib/abpbase'
    import PageRequest from '@/store/entities/page-request'
    import Enums from '@/lib/enums'
    import DateUtils from '@/common/js/DateUtils'


    class PageFlowRequest extends PageRequest {
        orderType: number;
        overTimeHours: number;
        PlatformType: number;
        constructor() {
            super();
            this.orderType = 0;
            this.overTimeHours = 24;
            this.PlatformType = null;
        }
    }

    @Component({
        name: "abnormalreceivingorder",
    })
    export default class flows extends AbpBase {
        ordertype = Enums.getEnum(Enums.WarehouseOrderType, true);
        PlatformType = Enums.getEnum(Enums.PlatformType, true);
        pagerequest: PageFlowRequest = new PageFlowRequest();
        createTime: Date[] = [];
        get list() {
            return this.$store.state.frontabnormalreceivingorder.list;
        };
        get loading() {
            return this.$store.state.frontabnormalreceivingorder.loading;
        };
        pageChange(page: number) {
            this.$store.commit('frontabnormalreceivingorder/setCurrentPage', page);
            this.getpage();
        };
        pagesizeChange(pagesize: number) {
            this.$store.commit('frontabnormalreceivingorder/setPageSize', pagesize);
            this.getpage();
        };

        async getpage() {
            this.pagerequest.maxResultCount = this.pageSize;
            this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
            //filters
            await this.$store.dispatch({
                type: 'frontabnormalreceivingorder/getAll',
                data: this.pagerequest
            })
        }
        async searchPage() {
            this.$store.state.frontabnormalreceivingorder.currentPage = 1;
            this.getpage();
        }
        get pageSize() {
            return this.$store.state.frontabnormalreceivingorder.pageSize;
        }
        get totalCount() {
            return this.$store.state.frontabnormalreceivingorder.totalCount;
        }
        get currentPage() {
            return this.$store.state.frontabnormalreceivingorder.currentPage;
        }
        columns = [{

            title: '仓库名称',
            key: 'warehouseName',
            width: 364,
            //fixed: 'left',
        }, {
            title: '用户编码',
            key: 'userCode',
            width: 400,
        }, {
            title: '订单编号',
            key: 'orderNumber',
            width: 400,

        }, {
            title: '接收时间',
            key: 'receivedTime',
            width: 400,
            render: (h: any, params: any) => {
                return h('span', params.row.receivedTime ? DateUtils.formatLongDate(new Date(params.row.receivedTime)) : '');
            }
        },
        ]
        async created() {
            this.getpage();
        }
    }
